import BaseListPage from "../../../../../base/BaseListPage";
import withRouter from "../../../../../utils/withRouter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import PageContainer from "../../../../../components/PageContainer/PageContainer";
import Search from "../../../../../components/Search";
import Table from "../../../../../components/Table";
import SingleSearchLogsListPresenter from "./SingleSearchLogsListPresenter";
import { formatDateTime } from "../../../../../utils/dateFormat";
import DateRange from "../../../../../components/DateRange";
import ExportPDF from "./components/ExportPDF";
import ExportCSV from "./components/ExportCSV";
import TableSearchLogs from "../../../../../components/TableSearchLogs";

class SingleSearchLogsListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new SingleSearchLogsListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase(),
    );

    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      dateFilter: {},
      exportObject: [],
      progress: 0, // 👈 add this
    };

    this.fieldsToDisplay = [
      "searcher",
      "searched_first_name",
      "searched_last_name",
      "searched_middle_name",
      "searched_alias",
      "createdAt",
    ];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  setDateFilter(date) {
    this.setState({ dateFilter: date });
  }

  getCollectionName() {
    return "search_logs";
  }

  onClickDeleteItem(index) {
    this.presenter.onClickDeleteItem(index);
  }

  formatObjects(objects) {
    return objects.map((object) => {
      return {
        ...object,
        createdAt: formatDateTime(object.createdAt),
        // searchedName: `${object.searched_first_name} ${object.searched_middle_name} ${object.searched_last_name} ${object.searched_alias}`,
        searchedName: object.searched_company
          ? object.searched_company
          : `${object.searched_first_name} ${
              object.searched_middle_name || ""
            } ${object.searched_last_name} ${object.searched_alias}`.trim(),
        credit: -1,
        searcher: `${object.searcher.firstName} ${
          object.searcher.middleName || ""
        } ${object.searcher.lastName}`,
        searcherObject: object.searcher,
      };
    });
  }

  formatFields(fields) {
    const {
      searched_first_name,
      searched_last_name,
      searched_middle_name,
      searched_alias,
      ...rest
    } = fields;

    return {
      ...rest,
      createdAt: {
        ...rest.createdAt,
        type: "String",
        label: "Search Date",
      },
      searchedName: {
        type: "String",
        label: "Searched Name",
      },
      credit: {
        type: "String",
        label: "Credited Amount",
      },
      searcher: {
        type: "String",
        label: "Affiliate User",
      },
    };
  }

  setObjectsExport(object) {
    this.setState({ exportObject: object });
  }

  setLoading(value) {
    this.setState({ loading: value });
  }

  setProgress(completed, total) {
    const percent = total > 0 ? Math.round((completed / total) * 100) : 0;
    this.setState({ progress: percent });
  }

  searchSubmit(where, merge) {
    this.presenter.searchSubmit(where, merge);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, dateFilter } = this.state;
    console.log("objects", objects);
    const DISPLAY_LIMIT = 500;
    const displayObjects = objects.slice(0, DISPLAY_LIMIT);

    return (
      <PageContainer
        title="Search Logs"
        navigateBack={this.navigateBack.bind(this)}
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <p style={{ fontSize: ".875rem" }}>
          <span style={{ fontSize: "1rem" }}>
            <i class="bi bi-info-circle-fill pe-2 text-secondary"></i>
          </span>
          To get started, please select a date range below..
        </p>
        <div className="w-100 d-flex gap-5 align-items-center justify-content-between">
          <div className="d-flex flex-row align-items-center gap-3">
            <DateRange
              field="createdAt"
              onChange={this.onChangeDate.bind(this)}
            />
            <Search
              schemas={this.getSchemas()}
              onSubmit={this.searchSubmit.bind(this)}
              fields={schema.fields}
            />
          </div>
          <div className="d-flex flex-row align-items-center gap-2">
            <ExportCSV data={objects} />
            <ExportPDF
              client={objects[0]?.searcher?.affiliate?.name}
              date={dateFilter}
              objects={objects}
            />
          </div>
        </div>
        <p className="m-0 text-end">
          {/* {objects.length > DISPLAY_LIMIT
            ? `Showing first ${DISPLAY_LIMIT} Total of ${objects.length} — use Export for full data`
            : `Total ${objects.length} of ${count}`} */}
          {objects.length > DISPLAY_LIMIT
            ? `Total of ${objects.length}`
            : `Total ${objects.length} of ${count}`}
        </p>
        {loading && (
          <div className="my-2 w-100">
            <div className="progress" style={{ height: "6px" }}>
              <div
                className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                role="progressbar"
                style={{ width: `${this.state.progress}%` }}
              />
            </div>
            <small className="text-muted">
              Loading... {this.state.progress}%
            </small>
          </div>
        )}
        <TableSearchLogs
          fields={this.formatFields(schema.fields)}
          objects={this.formatObjects(displayObjects)}
          progress={loading}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key),
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(SingleSearchLogsListPage);
